/**
 * Auto-submit select: change 이벤트마다 부모 form 을 자동 제출.
 *
 * 사용:
 *   <select data-auto-submit="1" ...> ... </select>
 *
 * SlimSelect 등 래퍼가 적용되어도 native change 이벤트는 그대로 발생하므로 호환된다.
 * 동적으로 추가된 select 도 scope 인자로 다시 호출하면 됨 (idempotent).
 */
export function initAutoSubmitSelects(scope: ParentNode = document): void {
  scope
    .querySelectorAll<HTMLSelectElement>('select[data-auto-submit="1"]')
    .forEach((sel) => {
      if (sel.dataset.autoSubmitBound === "1") return;
      sel.dataset.autoSubmitBound = "1";
      sel.addEventListener("change", () => {
        const form = sel.form;
        if (!form) return;
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
}
